import BlogPost from "../../../../src/templates/blog-post";
import { graphql } from 'gatsby';
import CodeExample from "../../../../src/components/CodeExample";
import Note from "../../../../src/components/Note";
import Code from "../../../../src/components/code";
import LittleImg from "../../../../src/components/LittleImg";
import * as React from 'react';
export default {
  BlogPost,
  graphql,
  CodeExample,
  Note,
  Code,
  LittleImg,
  React
};